import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

import Login from 'components/LandingPage/Login';
import SocialForm from 'components/SoonoSocial/Form';

import logo from 'assets/img/logo.png';
import soonoSocial from 'assets/img/soono-social.png';
import 'assets/scss/landingPage.css';
import 'assets/scss/soonoSocial.css';
import SocialIcons from '../components/LandingPage/SocialIcons';


class SoonoSocial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      loading: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="soono-social">
        <header className="social-header">
          <div className="navbar navbar-dark">
            <div className="container d-flex justify-content-between">
              <a href="/home" className="navbar-brand d-flex align-items-center">
                <img src={logo} title="Soono Logo" alt="Soono Logo" />
              </a>
              <Login />
            </div>
          </div>
        </header>

        <main role="main">
          <section className="why-soono">
            <div className="container">
              <div className="row">
                <div className="offset-md-1 col-md-11">
                  <p className="lead text-center">
                    Get ready to add some flare to your next event! Invite us to energize and engage
                    your audience, collect insightful feedback, and grow your email list with a
                    highly engaged audience.
                  </p>
                </div>
                <div className="col-md-6 d-flex justiy-content-center align-items-center">
                  <img src={soonoSocial} className="img-fluid" alt="Soono Survey" />
                </div>
                <div className="col-md-6">
                  <div className="why-soono-text">
                    <h2>How Soono Social Works?</h2>
                    <ul className="lead">
                      <li>
                        One of our delightful Soono Socials reps will work with you to create the
                        perfect interactive Trivia Survey for any event, ie Engagement Parties “Who
                        was the first to say I love you?”; Company Celebrations “Who has the most
                        Employee of the Month awards?”; Non-profit events “How many kids did our
                        organization support last year?”.
                      </li>
                      <li>
                        We’ll attend your event, facilitate the campaign and energize your audience
                      </li>
                      <li>
                        After your event, We’ll send out a Post event Feedback Survey to help you
                        gain meaningful insights and improve your next event.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="sign-up blue-bg text-white">
            <svg
              className="svg-bg bottom-curve"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
            >
              <polygon fill="#f5f5f5" points="50,50 0,100 100,100" />
            </svg>
            <svg
              className="svg-bg top-curve"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
            >
              <polygon fill="#f5f5f5" points="50,50 0,100 100,100" />
            </svg>
            <div className="container">
              <div className="row justify-content-md-center">
                <div className="col-md-7 text-center">
                  <h2 className="mt-4 mb-4">Want to book us for your next event?</h2>
                  <SocialForm />
                </div>
              </div>
            </div>
          </section>
        </main>

        <footer className="text-muted pt-4 pb-4">
          <div className="container">
            <p className="float-right">
              <a href="/#growBusiness">About Us</a>
              <Link to="/events">Events</Link>
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/terms-of-use">Terms and Conditions</Link>
            </p>
            <p>
              ©
              {' '}
              {new Date().getFullYear()}
              {' '}
              All rights reserved by
              {' '}
              <Link to="/home">Soono</Link>
              .
              <SocialIcons />
            </p>
          </div>
        </footer>
      </div>
    );
  }
}

export default SoonoSocial;



// WEBPACK FOOTER //
// ./src/containers/SoonoSocial.js